package com.vizio.redwolf.utils

import com.vizio.redwolf.utils.clientprovider.ClientProvider

data class ClientConfig(val clientProvider: ClientProvider, val timeout: Long = DEFAULT_TIMEOUT, val retryConfig: RetryConfig = DEFAULT_RETRY_CONFIG)